import { useTranslation } from 'react-i18next'
import { useNotifications } from '../../notifications/use-notifications'

type UseClipboard = {
  copyToClipboard: (
    getText: () => string | Promise<string | null>,
  ) => Promise<void>
}

export function useClipboard(): UseClipboard {
  const { enqueueWarning } = useNotifications()
  const { t } = useTranslation()

  const copyToClipboard = async (
    getText: () => string | Promise<string | null>,
  ) => {
    if (!navigator.clipboard) {
      enqueueWarning(t('clipboard.notSupported'))
      return
    }

    const text = await getText()
    if (text === null) {
      return
    }
    await navigator.clipboard.writeText(text)
  }

  return {
    copyToClipboard,
  }
}
